import Client from "./Typesense/Client";
import SearchClient from "./Typesense/SearchClient";
import * as Errors from "./Typesense/Errors";

export { Client, SearchClient, Errors };
export default { Client, SearchClient, Errors };
